import Toggle from "@/app/components/ui/Toggles";
import { PRIMARY_BUTTON, SECONDARY_BUTTON } from "@/constants";
import useFormValidations from "@/app/hooks/useFormValidations";
import Input from "@/app/components/ui/Inputs/Input";
import { Controller, useForm } from "react-hook-form";
import { ILabPartnerDetails } from "@/api_framework/api_modals/LabReport";
import { useLabPartnerOnboardingAPI } from "@/app/hooks/api_hooks/LabReport/useLabPartnerOnboardingAPI";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import CircleSpinnerLoader from "@/app/components/ui/Reusable/LoaderComponent/CircleSpinnerLoader";
import { useSearchParams } from "react-router-dom";
import { useLabPartnerDetailsAPI } from "@/app/hooks/api_hooks/LabReport/useLabPartnerDetailsAPI";
import { useLabAddPartnerAPI } from "@/app/hooks/api_hooks/LabReport/useLabAddPartnerAPI";
import { useLabPartnerListDropDownAPI } from "@/app/hooks/api_hooks/LabReport/useLabPartnerListDropDownAPI";
import GeoSearchSelectMenu from "@/app/components/ui/SelectMenus/GeoSearchSelectMenu";
import CreatableSelect from "react-select/creatable";
import { format } from "date-fns";
import LabOnboardCalendar from "@/app/components/ui/Calendar/LabOnboardCalendar";
import { XMarkIcon } from "@heroicons/react/24/outline";
import TimePicker from "../TimePicker";
import { useLabPartnerUpdateAPI } from "@/app/hooks/api_hooks/LabReport/useLabPartnerUpdateAPI";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import LabPartnerSearch from "@/app/components/ui/Reusable/LabPartnerSearch";
import { useClinicListAPI } from "@/app/hooks/api_hooks/org/useClinicListAPI";
import { useConfigurationClinicDetailAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationClinicDetailAPI";


const PartnerOnboardingComponent = () => {
  const { forOnlyNumbers, forOnlyNumbersWithDecimal } = useFormValidations();
  const { execute: onboardLabPartner } = useLabPartnerOnboardingAPI();
  const { execute: labPartnerUpdate } = useLabPartnerUpdateAPI();
  const { execute: fetchpartnerDetails, labPartnerDetails } = useLabPartnerDetailsAPI();

  const { execute: fetchLabPartnerListDropDown, labList } = useLabPartnerListDropDownAPI();
  const { execute: addLabPartner } = useLabAddPartnerAPI();
  const [loader, setLoader] = useState(false);
  const [addLoader, setAddLoader] = useState(false);
  const navigate = useNavigate();
  const [params, _setParams] = useSearchParams();
  const [selectedHolidays, setSelectedHolidays] = useState<Date[]>([]);
  const [isActive, setIsActive] = useState(false);
  const labPartnerList = useSelectMenuReducer(labList, "name", "lab_partner_id");
  const { execute: fetchClinicListAPI, clinicList } = useClinicListAPI();
  const { clinicDetails, execute: fetchClinicDetail } = useConfigurationClinicDetailAPI();

  const lab_id: string | null = params.get("lab_id");
  // console.log("labPartnerList new", labPartnerList);

  const formHook = useForm<any>({
    mode: "onChange",
  });

  useEffect(() => {
    fetchClinicListAPI();
  }, [fetchClinicListAPI]);

  const clinicsOrgItem = useMemo(() => {
    if (!clinicList || clinicList.length === 0) return [];
    return clinicList.map((clinic: any) => ({
      id: clinic.id,
      title: clinic.clinic_name,
    }));
  }, [clinicList]);

  useEffect(() => {
    if (lab_id) {
      fetchpartnerDetails(lab_id);
    }
  }, [lab_id]);
  // console.log("labPartnerDetails", labPartnerDetails);

  useEffect(() => {
    if (labPartnerDetails && lab_id) {
      const partnerDetails = lab_id && labPartnerDetails;
      formHook.setValue("lab_name", partnerDetails?.lab_name);
      formHook.setValue("branch_name", partnerDetails?.branch_name);
      formHook.setValue("contact_email", partnerDetails?.contact_email);
      formHook.setValue("contact_phone", partnerDetails?.contact_phone);
      formHook.setValue("address_details", partnerDetails?.address_details);
      formHook.setValue("addressLine1", partnerDetails?.address_details?.addressLine1);
      formHook.setValue("addressLine2", partnerDetails?.address_details?.addressLine2);
      formHook.setValue("city", partnerDetails?.address_details?.city);
      formHook.setValue("state", partnerDetails?.address_details?.state);
      formHook.setValue("pincode", partnerDetails?.pincode);
      formHook.setValue("latitude", partnerDetails?.latitude);
      formHook.setValue("longitude", partnerDetails?.longitude);
      formHook.setValue("opens_at", partnerDetails?.opens_at);
      formHook.setValue("closes_at", partnerDetails?.closes_at);
      formHook.setValue("holidays", partnerDetails?.holidays);
      formHook.setValue("is_vetic_lab", partnerDetails?.is_vetic_lab);
      formHook.setValue("partner_id", partnerDetails?.partner_id);
      formHook.setValue("bank_details", partnerDetails?.bank_details);
      formHook.setValue("account_holder_name", partnerDetails?.bank_details?.account_holder_name);
      formHook.setValue("account_number", partnerDetails?.bank_details?.account_number);
      formHook.setValue("ifsc_number", partnerDetails?.bank_details?.ifsc_number);
      formHook.setValue("bank_name", partnerDetails?.bank_details?.bank_name);
      formHook.setValue("status", partnerDetails?.status);
    }
  }, [labPartnerDetails, lab_id]);

  const onSubmit = (data: ILabPartnerDetails, e: React.FormEvent) => {
    e.preventDefault();
    setLoader(true);
    
    const formattedHolidays = (data.holidays || []).map((dateStr: string) => {
      if (dateStr.includes("T")) {
        return dateStr;
      }
      return `${dateStr}T00:00:00+05:30`;
    });


    const constructedBody: any = {
      lab_name: data?.lab_name,
      partner_id: data?.partner_id,
      branch_name: data.branch_name,
      contact_email: data.contact_email,
      contact_phone: data.contact_phone,
      address_details: {
        addressLine1: data?.addressLine1 || "",
        addressLine2: data?.addressLine2 || "",
        city: data?.city || "",
        state: data?.state || "",
      },
      pincode: data.pincode,
      latitude: data.latitude,
      longitude: data.longitude,
      opens_at: data.opens_at,
      closes_at: data.closes_at,
      holidays: formattedHolidays,
      is_vetic_lab: data.is_vetic_lab || false,
      status: data.status || "inactive",
      clinic_id: formHook.watch("is_vetic_lab") && formHook.watch("clinics")?.length > 0 ? formHook.watch("clinics")[0] : undefined,
      bank_details: {
        account_holder_name: data.account_holder_name || "",
        account_number: data.account_number || null,
        ifsc_number: data.ifsc_number || "",
        bank_name: data.bank_name || "",
      },
    };

    if (!lab_id) {
      constructedBody.partner_id = data.partner_id;
    }

    if (!lab_id) {
      onboardLabPartner(constructedBody).then(({ status, message }) => {
        setLoader(false);
        if (status) {
          navigate(`/app/clinic-lab-report/lab-partner-onboard?lab_id=${message}&step=LAB_TEST`);
        }
      });
    } else {
      labPartnerUpdate(constructedBody, lab_id).then(({ status }) => {
        setLoader(false);
        if (status) {
          navigate(`/app/clinic-lab-report/lab-partner-onboard?lab_id=${lab_id}&step=LAB_TEST`);
        }
      });
    }
  };

  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      "@apply text-sm": "text-xs",
    }),
    singleValue: (provided) => ({
      ...provided,
      "@apply text-sm": "",
    }),
    multiValue: (provided) => ({
      ...provided,
      "@apply text-sm": "text-xs",
    }),
    input: (provided) => ({
      ...provided,
      "@apply text-sm": "",
    }),
  };

  useEffect(() => {
    if (!labPartnerDetails) return;
    formHook.reset({
      lab_name: labPartnerDetails.lab_name || "",
      branch_name: labPartnerDetails.branch_name || "",
      contact_email: labPartnerDetails.contact_email || [],
      contact_phone: labPartnerDetails.contact_phone || [],
      address_details: {
        addressLine1: labPartnerDetails.address_details?.addressLine1 || "",
        addressLine2: labPartnerDetails.address_details?.addressLine2 || "",
        city: labPartnerDetails.address_details?.city || "",
        state: labPartnerDetails.address_details?.state || "",
      },
      opens_at: labPartnerDetails.opens_at || "",
      closes_at: labPartnerDetails.closes_at || "",
      holidays: labPartnerDetails.holidays || [],
      is_vetic_lab: labPartnerDetails.is_vetic_lab || false,
      status: labPartnerDetails.status,

      partner_id: labPartnerDetails.partner_id || undefined,
      bank_details: {
        account_holder_name: labPartnerDetails.bank_details?.account_holder_name || "",
        account_number: labPartnerDetails.bank_details?.account_number || null,
        ifsc_number: labPartnerDetails.bank_details?.ifsc_number || "",
        bank_name: labPartnerDetails.bank_details?.bank_name || "",
      },
    });

    if (Array.isArray(labPartnerDetails.holidays)) {
      const parsedDates = labPartnerDetails.holidays.map((d: string) => new Date(d));
      setSelectedHolidays(parsedDates || []);
    } else {
      setSelectedHolidays([]);
    }
  }, [labPartnerDetails]);

  useEffect(() => {
    fetchLabPartnerListDropDown();
  }, []);

  const handelCreateItems = async (item: string) => {
    const labName = item.trim();
    if (!labName) return;

    setAddLoader(true);
    const payLoad: any = {
      partner_name: labName,
    };
    addLabPartner(payLoad).then(({ status, lab_partner_id }) => {
      if (status && lab_partner_id) {
        fetchLabPartnerListDropDown().then(({ status }) => {
          status && formHook.setValue("lab_name", lab_partner_id?.name);
          status && formHook.setValue("partner_id", lab_partner_id?.partner_id);
        });
      }
      setAddLoader(false);
    });
  };

  useEffect(() => {
    if (!clinicDetails?.clinic_data) return;
    const clinic = clinicDetails.clinic_data;
    formHook.setValue("addressLine1", clinic?.address || "");
    formHook.setValue("addressLine2", clinic?.address2 || "");
    formHook.setValue("city", clinic?.city_details?.name || "");
    formHook.setValue("state", clinic?.state || "");
    formHook.setValue("pincode", clinic?.pincode || "");
    formHook.setValue("latitude", clinic?.latitude || "");
    formHook.setValue("longitude", clinic?.longitude || "");
  }, [clinicDetails]);


  return (
    <form onSubmit={formHook.handleSubmit(onSubmit)} className="w-full min-h-screen bg-[#F9FAFB] p-2 lg:max-w-6xl">
      <div className="bg-white py-3 px-3 rounded-xl flex flex-col lg:flex-row justify-between lg:items-center align-middle gap-3 lg:gap-0">
        <h1 className="text-sm font-semibold text-gray-800">
          Onboarding New Lab
        </h1>
        <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-3 lg:gap-6">
          <div className="flex items-center gap-3 w-full lg:w-auto">
            <div className="flex flex-wrap items-center gap-2 w-full lg:w-auto">
              <p className="text-sm shrink-0">Is Vetic Lab</p>
              <Toggle
                checked={formHook.watch("is_vetic_lab")}
                className="w-10 h-5 rounded-full relative transition bg-[#F05B72]"
                onToggle={(isOn: boolean) => {
                  formHook.setValue("is_vetic_lab", isOn, {
                    shouldDirty: true,
                  });
                }}
              />
              {formHook.watch("is_vetic_lab") && (
                <div className="flex items-center gap-2 w-full sm:w-auto">
                  <div className="w-full sm:w-[260px]">
                    <SearchableSelectMenu
                      errorMessages={[]}
                      onSelectItem={(item) => {
                        if (!item) return;
                        formHook.setValue("clinics", [item.id], {
                          shouldDirty: true,
                          shouldValidate: true,
                        });
                        fetchClinicDetail(item.id);
                      }}
                      fieldError={formHook.formState.errors.clinics}
                      register={formHook.register("clinics", { required: false })}
                      selectItems={clinicsOrgItem}
                      placeholder="Select Clinic"
                      showTooltips
                      showTypedErrors={false}
                      showDropdownIcon
                      defaultSelected={clinicsOrgItem.find((oc) =>
                        formHook.watch("clinics")?.includes(oc.id)
                      )}
                      listBoxClassName="w-full"
                      className="text-gray-800"
                      containerClassName="w-full"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="w-full lg:w-[280px]">
            <LabPartnerSearch
              searchType="Lab"
              containerClassName="w-full shadow-none"
              inputContainerClassName="w-full"
              itemActiveClassName="bg-orange-500 text-white"
              flexibleAdd={false}
              onSelectItem={(item) => {
                if (!item) return;
                fetchpartnerDetails(item.id);
              }}
            />
          </div>
        </div>
      </div>


      <div className="bg-white p-2 rounded-xl space-y-10 mt-2">
        <div>
          <h2 className="text-gray-500 text-sm mb-2">
            Basic Information<span className="text-red-600 text-xs ml-1">*</span>{" "}
          </h2>
          <div className="bg-[#F9FAFB] py-4 px-3 rounded-xl">
            <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4 bg-grey-500">
              <div>
                <div className="flex">
                  <p>Lab Name</p>
                  <span className="text-red-600 text-xs ml-1"> *</span>
                </div>
                <div className="w-full mt-2">
                  <div className=" mt-2">
                    <SearchableSelectMenu
                      errorMessages={[{ message: "", type: "required" }]}
                      fieldError={formHook.formState.errors?.lab_name}
                      register={formHook.register("lab_name", { required: true })}
                      placeholder="Select or Add Lab"
                      showTooltips
                      showTypedErrors
                      showDropdownIcon
                      className="text-gray-800"
                      containerClassName="w-full"
                      selectItems={labPartnerList}
                      onSelectItem={(item) => {
                        if (!item) return;
                        formHook.setValue("lab_name", item.title, { shouldDirty: true, shouldValidate: true });
                        formHook.setValue("partner_id", item.id, { shouldDirty: true });
                      }}
                      addAction={{
                        title: "+ Add",
                        callBack: handelCreateItems,
                      }}
                      defaultSelected={labPartnerList?.filter((oc) => oc.id === formHook.watch("partner_id"))[0]}
                    />
                  </div>
                </div>
              </div>

              <div>
                <div className="flex">
                  <p>Branch Name</p>
                  <span className="text-red-600 text-xs ml-1">*</span>
                </div>
                <div className="w-full mt-2">
                  <Input
                    className="text-xs"
                    inputClassName="!h-9"
                    placeholder="Enter branch name"
                    register={formHook.register("branch_name", {
                      required: true,
                    })}
                    fieldError={formHook.formState.errors?.branch_name}
                    errorMessages={[{ message: "", type: "required" }]}
                  />
                </div>
              </div>

              <div>
                <div className="flex">
                  <p>Email ID</p>
                  <span className="text-red-600 text-xs ml-1">*</span>
                </div>
                <div className="w-full mt-2 border rounded-lg">
                  <Controller
                    name="contact_email"
                    control={formHook?.control}
                    rules={{
                      required: "Email is required",
                      validate: (value) => value?.length > 0 || "At least one email is required",
                    }}
                    render={({ field }) => (
                      <CreatableSelect
                        isMulti
                        value={(field?.value || [])?.map((email: string) => ({
                          label: email,
                          value: email,
                        }))}
                        onChange={(options: any) => {
                          const emails = options ? options?.map((o: any) => o?.value?.trim())?.filter(Boolean) : [];
                          field?.onChange(emails);
                        }}
                        className="text-xs border-none"
                        styles={customStyles}
                        placeholder="Enter email addresses..."
                      />
                    )}
                  />
                </div>
                {formHook.formState.errors?.contact_email && (
                  <p className="text-red-600 text-xs mt-1">
                    {formHook.formState.errors?.contact_email.message as string}
                  </p>
                )}
              </div>

              <div>
                <div className="flex">
                  <p>POC Phone Number</p>
                  <span className="text-red-600 text-xs ml-1">*</span>
                </div>
                <div className="border rounded-lg h-auto mt-2">
                  <Controller
                    name="contact_phone"
                    control={formHook?.control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) => value?.length > 0 || "At least one phone number is required",
                    }}
                    render={({ field }) => (
                      <CreatableSelect
                        isMulti
                        value={(field?.value || [])?.map((t: string) => ({
                          label: t,
                          value: t,
                        }))}
                        onChange={(newValue: any) => {
                          const cleaned = newValue ? newValue?.map((o: any) => o?.value?.trim())?.filter(Boolean) : [];
                          field?.onChange(cleaned);
                        }}
                        className="text-xs border-none"
                        styles={customStyles}
                        placeholder="You can add multiple number by tapping enter key"
                      />
                    )}
                  />
                </div>

                {formHook.formState.errors.contact_phone && (
                  <p className="text-red-600 text-xs mt-1">
                    {formHook.formState.errors.contact_phone.message as string}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white p-2 rounded-xl space-y-10 mt-2">
        <div>
          <h2 className="text-gray-500 text-sm mb-2">
            Branch Address <span className="text-red-600 text-xs ml-1">*</span>
          </h2>

          <div className="bg-[#F9FAFB] py-3 px-2 rounded-xl">
            <div className="relative w-full max-w-md  mr-8 mb-4">
              <GeoSearchSelectMenu
                autoComplete="off"
                autoCorrect="false"
                showDropdownWhenNoData
                withClearAction
                placeholder="Search Google Location"
                onClear={() => {
                  formHook.setValue("addressLine1", "");
                  formHook.setValue("addressLine2", "");
                  formHook.setValue("city", "");
                  formHook.setValue("state", "");
                  formHook.setValue("pincode", "");
                  formHook.setValue("latitude", null);
                  formHook.setValue("longitude", null);
                }}
                onSelectItem={(item) => {
                  if (!item) return;

                  formHook.setValue("addressLine1", item.state.formattedAddress, { shouldDirty: true });

                  formHook.setValue("city", item.state.city, { shouldDirty: true });

                  formHook.setValue("state", item.state.state, { shouldDirty: true });

                  formHook.setValue("pincode", item.state.pincode, { shouldDirty: true });
                  formHook.setValue("latitude", item.state.lat);
                  formHook.setValue("longitude", item.state.long);
                }}
                errorMessages={[{ message: "", type: "required" }]}
                fieldError={formHook.formState.errors?.address_details}
                register={formHook.register("address_details", {
                  required: false,
                })}
                showTypedErrors
              />
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4 bg-grey-500">
              <div>
                <div className="flex">
                  <p>Address Line 1</p>
                  <span className="text-red-600 text-xs ml-1">*</span>
                </div>
                <div className="w-full mt-2">
                  <Input
                    className="text-xs"
                    inputClassName="!h-9"
                    placeholder="Add Address"
                    register={formHook.register("addressLine2", {
                      required: true,
                    })}
                    fieldError={formHook.formState.errors?.addressLine2}
                    errorMessages={[{ message: "", type: "required" }]}
                  />
                </div>
              </div>

              <div>
                <div className="flex">
                  <p>Address Line 2</p>
                </div>
                <div className="w-full mt-2">
                  <Input
                    className="text-xs"
                    inputClassName="!h-9"
                    placeholder="Add Address (Optional)"
                    register={formHook.register("addressLine1", {
                      required: false,
                    })}
                    fieldError={formHook.formState.errors?.addressLine1}
                    errorMessages={[{ message: "", type: "required" }]}
                  />
                </div>
              </div>

              <div>
                <div className="flex">
                  <p>City</p>
                  <span className="text-red-600 text-xs ml-1">*</span>
                </div>
                <div className="w-full mt-2">
                  <Input
                    className="text-xs"
                    inputClassName="!h-9"
                    placeholder="Enter city name"
                    register={formHook.register("city", {
                      required: true,
                    })}
                    fieldError={formHook.formState.errors?.city}
                    errorMessages={[{ message: "", type: "required" }]}
                  />
                </div>
              </div>

              <div>
                <div className="flex">
                  <p>State</p>
                  <span className="text-red-600 text-xs ml-1">*</span>
                </div>
                <div className="w-full mt-2">
                  <Input
                    className="text-xs"
                    inputClassName="!h-9"
                    placeholder="e.g. Enter state name"
                    register={formHook.register("state", {
                      required: true,
                    })}
                    fieldError={formHook.formState.errors?.state}
                    errorMessages={[{ message: "", type: "required" }]}
                  />
                </div>
              </div>
              <div>
                <div className="flex">
                  <p>Pincode</p>
                  <span className="text-red-600 text-xs ml-1">*</span>
                </div>
                <div className="w-full mt-2">
                  <Input
                    className="text-xs"
                    inputClassName="!h-9"
                    placeholder="e.g. 301019"
                    register={formHook.register("pincode", {
                      required: true,
                      ...forOnlyNumbers.validations,
                    })}
                    fieldError={formHook.formState.errors?.pincode}
                    errorMessages={[forOnlyNumbers.errors, { message: "", type: "required" }]}
                    maxLength={6}
                  />
                </div>
              </div>

              <div className="flex flex-col sm:flex-row w-full gap-4">
                <div className="w-full">
                  <div className="flex">
                    <p>Lattitude</p>
                    <span className="text-red-600 text-xs ml-1">*</span>
                  </div>
                  <div className="w-full mt-2">
                    <Input
                      className="text-xs"
                      inputClassName="!h-9"
                      placeholder="e.g. 5432.1234"
                      register={formHook.register("latitude", {
                        required: true,
                        ...forOnlyNumbersWithDecimal.validations,
                      })}
                      fieldError={formHook.formState.errors?.latitude}
                      errorMessages={[{ message: "", type: "required" }]}
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="flex">
                    <p>Longitude</p>
                    <span className="text-red-600 text-xs ml-1">*</span>
                  </div>
                  <div className="w-full mt-2">
                    <Input
                      className="text-xs"
                      inputClassName="!h-9"
                      placeholder="e.g. 1234.5432"
                      register={formHook.register("longitude", {
                        required: true,
                        ...forOnlyNumbersWithDecimal.validations,
                      })}
                      fieldError={formHook.formState.errors?.longitude}
                      errorMessages={[{ message: "", type: "required" }]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white p-2 rounded-xl space-y-10 mt-2">
        <div>
          <h2 className="text-gray-500 text-sm mb-2">
            Opening Hours <span className="text-red-600 text-xs ml-1">*</span>
          </h2>

          <div className="bg-[#F9FAFB] py-4 px-3 rounded-xl">
            <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4 bg-grey-500">
              <div>
                <div className="flex">
                  <p>Opening Time</p>
                  <span className="text-red-600 text-xs ml-1">*</span>
                </div>
                <div className="w-full mt-2">
                  <TimePicker
                    value={formHook?.watch("opens_at") || ""}
                    onChange={(time) => {
                      formHook.setValue("opens_at", time);
                      formHook.clearErrors("opens_at");
                    }}
                    placeholder="Select Time"
                    register={formHook.register("opens_at", {
                      required: "Opening time is required",
                    })}
                    error={formHook.formState.errors?.opens_at}
                    className="text-xs"
                  />
                  {formHook.formState.errors?.opens_at && (
                    <p className="text-red-600 text-xs mt-1">{formHook.formState.errors.opens_at.message as string}</p>
                  )}
                </div>
              </div>

              <div>
                <div className="flex">
                  <p>Closing Time</p>
                  <span className="text-red-600 text-xs ml-1"> *</span>
                </div>
                <div className="w-full mt-2">
                  <TimePicker
                    value={formHook?.watch("closes_at") || ""}
                    onChange={(time) => {
                      formHook.setValue("closes_at", time);
                      formHook.clearErrors("closes_at");
                    }}
                    placeholder="Select Time"
                    register={formHook.register("closes_at", {
                      required: "Closing time is required",
                    })}
                    error={formHook.formState.errors?.closes_at}
                    className="text-xs"
                  />
                  {formHook.formState.errors?.closes_at && (
                    <p className="text-red-600 text-xs mt-1">{formHook.formState.errors.closes_at.message as string}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white p-2 rounded-xl space-y-6 mt-2">
        <div>
          <h2 className="text-gray-500 mb-2 text-sm">Holiday Schedule</h2>
          <div className="flex flex-wrap gap-3 mt-4 bg-[#F9FAFB] p-2 rounded-xl">
            <LabOnboardCalendar
              allowPastDaySelection={false}
              showTypedErrors={false}
              showLeftNav={false}
              allowMultipleSelection={true}
              closeOnSelect={false}
              selectedDates={selectedHolidays}
              register={null}
              errorMessages={[]}
              fieldError={null}
              defaultSelectedDate={undefined}
              onSelectDates={(dates) => {
                setSelectedHolidays(dates);
                const formattedDates = dates.map((date) => format(date, "yyyy-MM-dd"));
                formHook.setValue("holidays", formattedDates);
              }}
              className=""
            />

            {Array.isArray(selectedHolidays) &&
              selectedHolidays.length > 0 &&
              selectedHolidays
                .filter((d) => d instanceof Date && !isNaN(d.getTime()))
                .sort((a, b) => a.getTime() - b.getTime())
                .map((date, idx) => {
                  const formattedDate = format(date, "d MMM, yy");

                  return (
                    <span
                      key={`${date.getTime()}-${idx}`}
                      className="px-4 py-2 bg-[#F0F0F0] text-gray-700 text-sm rounded-full flex items-center gap-2"
                    >
                      {formattedDate}

                      <button
                        type="button"
                        onClick={() => {
                          const updatedDates = selectedHolidays.filter((_, i) => i !== idx);

                          setSelectedHolidays(updatedDates);

                          const formattedDates = updatedDates.map((d) => format(d, "yyyy-MM-dd"));

                          formHook.setValue("holidays", formattedDates);
                        }}
                        className="hover:bg-gray-300 rounded-full p-0.5 transition-colors"
                      >
                        <XMarkIcon className="w-3 h-3" />
                      </button>
                    </span>
                  );
                })}
          </div>
        </div>
      </div>

      <div className="bg-white p-2 rounded-xl space-y-10 mt-2">
        <div>
          <h2 className="text-gray-500 mb-2 text-sm">Bank Details</h2>

          <div className="bg-[#F9FAFB] py-4 px-3 rounded-xl">
            <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4 bg-grey-500">
              <div>
                <div className="flex">
                  <p>Account Holder Name</p>
                </div>
                <div className="w-full mt-2">
                  <Input
                    className="text-xs"
                    inputClassName="!h-9"
                    placeholder="Enter account holder name"
                    register={formHook.register("account_holder_name", {
                      required: false,
                    })}
                    fieldError={formHook.formState.errors?.account_holder_name}
                    errorMessages={[{ message: "Account holder name is required", type: "required" }]}
                  />
                </div>
              </div>

              <div>
                <div className="flex">
                  <p>Account Number</p>
                </div>
                <div className="w-full mt-2">
                  <Input
                    className="text-xs"
                    inputClassName="!h-9"
                    placeholder="Enter account number"
                    register={formHook.register("account_number", {
                      required: false,
                      ...forOnlyNumbers.validations,
                    })}
                    fieldError={formHook.formState.errors?.account_number}
                    errorMessages={[{ message: "Account number is required", type: "required" }]}
                  />
                </div>
              </div>

              <div>
                <div className="flex">
                  <p>IFSC Code</p>
                </div>
                <div className="w-full mt-2">
                  <Input
                    className="text-xs"
                    inputClassName="!h-9"
                    placeholder="Enter IFSC code"
                    register={formHook.register("ifsc_number", {
                      required: false,
                    })}
                    fieldError={formHook.formState.errors?.ifsc_number}
                    errorMessages={[{ message: "IFSC code is required", type: "required" }]}
                  />
                </div>
              </div>

              <div>
                <div className="flex">
                  <p>Bank Name</p>
                </div>
                <div className="w-full mt-2">
                  <Input
                    className="text-xs"
                    inputClassName="!h-9"
                    placeholder="Enter bank name"
                    register={formHook.register("bank_name", {
                      required: false,
                    })}
                    fieldError={formHook.formState.errors?.bank_name}
                    errorMessages={[{ message: "Bank name is required", type: "required" }]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white p-2 rounded-xl space-y-6 mt-2">
        <div className="py-4 px-3 bg-[#F9FAFB] rounded-xl">
          <div className="grid grid-cols-[60px_auto] items-center gap-y-4">
            <p className="font-semibold text-sm">Status</p>
            <Toggle
              checked={formHook.watch("status") === "active"}
              className="w-10 h-5 rounded-full relative transition bg-[#F05B72]"
              onToggle={(isOn: boolean) => {
                formHook.setValue("status", isOn ? "active" : "inactive", { shouldDirty: true });
              }}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-4 mt-6">
        <button
          type="button"
          className={SECONDARY_BUTTON}
          onClick={() => navigate("/app/clinic-lab-report/lab-partner-list")}
        >
          Cancel
        </button>

        <button type="submit" className={PRIMARY_BUTTON}>
          {loader ? <CircleSpinnerLoader h="20" w="20" /> : "Next"}
        </button>
      </div>
    </form>
  );
};

export default PartnerOnboardingComponent;
